import { Menu } from 'antd'
import React from 'react'

interface NavbarMenuProps {
    setActiveTab: any
}

const NavbarMenu: React.FC<NavbarMenuProps> = ({ setActiveTab }) => {
    return(
        <div className='navbar-tabs'>
            <Menu mode='horizontal'>
                <Menu.Item key='1' onClick={() => setActiveTab('home')}>Home</Menu.Item>
                <Menu.Item key='2' onClick={() => setActiveTab('how')}>How it Works?</Menu.Item>
                <Menu.Item key='3' onClick={() => setActiveTab('about')}>About Us</Menu.Item>
            </Menu>
        </div>
    )
}

export default NavbarMenu